import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AlreadyAuthenticatedGuard implements CanActivate {
 
  constructor(private auth: AuthenticationService, private router:Router) {
     }
 
  async canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    // console.log('already authenticated guard');
    try{
      const currentUser = await this.auth.getUser();
      // console.log('user',currentUser);
      if(currentUser){
        if(!currentUser.emailVerified){
          return this.router.createUrlTree(['/action'], { queryParams: { mode: 'sendEmailVerification' }});
        }
        else if (!currentUser.role){
          await this.auth.logout();
          return true;
        }
        else {
          // console.log('authenticated, navigate home');
          return this.router.parseUrl(currentUser.role+'/'+currentUser.uid);
        }
      }
      else{
        // console.log('not authenticated');
        return true;
      }
    }
    catch(e){
      console.log(e);
      return true;
    }
  }
}